"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var ColumnFlowsQueryGql_1 = require("../../queries/ColumnFlowsQueryGql");
var PaginatedQueryWrapper_1 = require("../../wrappers/PaginatedQueryWrapper");
var LinksDisplayGrid_1 = require("../sharedDisplayGrid/LinksDisplayGrid");
function selectConnectionListResult(resultData) {
    return resultData && resultData.columns && resultData.columns[0] && resultData.columns[0].referencedByFlowColumnInputFieldConnection;
}
function mapResultNode(node) {
    return {
        id: node.id,
        name: node.name,
        flowId: node.flow && node.flow.vizportalUrlId || '',
        flowName: node.flow && node.flow.name || ''
    };
}
function urlForLink(urls, rowData) {
    return urls.flowLineageFieldPath(rowData.flowId, rowData.id);
}
function nameForLink(rowData) {
    if (rowData.name === null) {
        return null;
    }
    return Localize_1.Messages.LinkNameWithParent({ name: rowData.name, parentName: rowData.flowName });
}
function ColumnFlowsQueryGrid(props) {
    var emptyGridMessage = Localize_1.Messages.EmptyColumnUsedByFlowsGridMessage();
    return (React.createElement(PaginatedQueryWrapper_1.PaginatedQueryWrapper, { queryGql: ColumnFlowsQueryGql_1.ColumnFlowsQueryGql, partialQueryVariables: { columnId: props.columnId }, selectConnectionListResult: selectConnectionListResult, mapResultNode: mapResultNode }, function (_a) {
        var rowStore = _a.rowStore;
        return React.createElement(LinksDisplayGrid_1.LinksDisplayGrid, { rowStore: rowStore, emptyGridMessage: emptyGridMessage, rowCount: props.rowCount, link: urlForLink, name: nameForLink });
    }));
}
exports.ColumnFlowsQueryGrid = ColumnFlowsQueryGrid;
//# sourceMappingURL=ColumnFlowsQueryGrid.js.map